/** Registers the Sprite2D parser and property formatter. */
import { nodeRegistry } from '../../../core/NodeRegistry';
import { parseSprite2D } from './parser';
import { formatSprite2DProperties } from './propertyFormatter';
const sprite2DRegistration = {
    typeName: 'Sprite2D',
    parser: parseSprite2D,
    propertyFormatter: formatSprite2DProperties,
};
nodeRegistry.register(sprite2DRegistration);
export * from './parser';
export * from './propertyFormatter';
export * from './types';
//# sourceMappingURL=index.js.map